export default __webpack_public_path__ + "static/media/spacex-logo.e755fcbf.png";